import React, { PropsWithChildren, useRef, useState } from 'react';
import { Swiper } from 'swiper/types';
import { Swiper as SwiperRoot } from 'swiper/react';
import { Autoplay, Keyboard, Controller } from 'swiper/modules';
import { BannersCarouselControl } from './banners-carousel-control';
import { BannersCarouselSliderWrapperStyles } from '../styles';
import { BannersCarouselSliderProps } from '../types';
import { useSwiperFocus } from '../hooks/use-swiper-focus';

import 'swiper/css';

const SwiperSliderItemsWrapper: React.FC<PropsWithChildren> = ({ children }) => <>{children}</>;

SwiperSliderItemsWrapper.displayName = 'SwiperSliderItemsWrapper';

export const BannersCarouselSlider: React.FC<BannersCarouselSliderProps> = props => {
  const { children, autoplay, loop, slidesPerView = 1, ...restProps } = props;

  const [swiper, setSwiper] = useState<Swiper>();

  const containerRef = useRef<HTMLDivElement>(null);

  useSwiperFocus(swiper, containerRef);

  return (
    <div className={BannersCarouselSliderWrapperStyles} ref={containerRef} {...restProps}>
      <SwiperRoot
        modules={[Autoplay, Keyboard, Controller]}
        autoplay={!!autoplay && { delay: autoplay, disableOnInteraction: false }}
        slidesPerView={slidesPerView}
        spaceBetween={12}
        keyboard={{
          enabled: true,
          onlyInViewport: true,
          pageUpDown: false,
        }}
        roundLengths
        observer
        onSwiper={setSwiper}
        {...{ loop }}>
        <SwiperSliderItemsWrapper>{children}</SwiperSliderItemsWrapper>
      </SwiperRoot>
      {swiper && <BannersCarouselControl direction="left" {...{ swiper, loop }} />}
      {swiper && <BannersCarouselControl direction="right" {...{ swiper, loop }} />}
    </div>
  );
};
